import Dashboard from 'app/developer-v3/pages/dashboard';

export default {
  routes: {
    '.': Dashboard,
  },
};
